import React from 'react';

const Loading = () => <div className="col-8"> loading ...</div>;

export default Loading;
